import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import * as PAGES from "../pages/pages";
import DashboardLayout from "../layout/DashboardLayout";
import RequireAuth from "../layout/RequireAuth";
import { PROTECTED_ROUTES, PUBLIC_ROUTES } from "./exportRoutes";

const Routing: React.FC = () => (
  <Router>
    <Routes>
      {PUBLIC_ROUTES.map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}

      <Route element={<RequireAuth />}>
        <Route element={<DashboardLayout />}>
          {PROTECTED_ROUTES.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>
      </Route>

      <Route path="*" element={<PAGES.PageNotFound />} />
    </Routes>
  </Router>
);

export default Routing;
